import { PhotoshopController } from "../photoshopController.js";
import * as noUiSlider from '../../node_modules/nouislider';

declare global {
    interface HTMLElement {
        noUiSlider?: noUiSlider.API;
    }
}

export class ToolsParemetersWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    size: HTMLElement | null;
    constructor(parentElement, controller) {
        this.parentElement = parentElement;
        this.photoshopController = controller;

        const sizeHardnessElem = document.getElementById("tool-setting-sizeHardness");
        if (sizeHardnessElem) {
            sizeHardnessElem.addEventListener("click", function () {
                this.tool_setting_sizeHardnessOnCLick();
                this.updateShow();
                this.updateModel();
            }.bind(this));
        }

        const expositionInput = document.getElementById("tool-setting-exposition-input");
        if (expositionInput) {
            expositionInput.addEventListener("change", function (event) {
                this.tool_setting_exposition_inputOnChange(event.currentTarget.valueAsNumber);
                this.updateModel();
            }.bind(this));
        }

        const rotationInputButton = document.getElementById("tool-setting-rotation-input-button");
        if (rotationInputButton) {
            rotationInputButton.addEventListener("change", function (event) {
                this.tool_setting_rotation_input_buttonOnChange(parseInt((event.currentTarget as HTMLInputElement).value));
                this.updateModel();
                this.photoshopController.update();
            }.bind(this));
        }

        const rotationInputSlider = document.getElementById("tool-setting-rotation-input-slider");
        if (rotationInputSlider) {
            rotationInputSlider.addEventListener("input", function (event) {
                this.tool_setting_rotation_input_sliderOnChange(parseInt((event.currentTarget as HTMLInputElement).value));
                this.updateModel();
                this.photoshopController.update();
            }.bind(this));
        }
    }

    static html() {
        return `
            <div style="height: 40px;">
                <div id="tool-setting" style="display: none;">
                    <div
                        style="float: left; width: 40px; height: 40px; text-align: center; line-height: 25px; position: relative;">
                        <div id="tool-setting-sizeHardness">
                            <i class="fas fa-circle"></i>
                            <div style="position: absolute; top: 8px; right: 0; font-size: 10px">
                                <i class="fas fa-chevron-down"></i>
                            </div>
                            <div id="tool-setting-size" style="position: absolute; bottom: 0; left: 0; right: 0; font-size: 10px">
                            </div>
                        </div>
                        <div id="tool-setting-sizeHardness-show"
                            style="position: absolute; top: 40px; background-color: #535353; padding: 10px; border: 1px solid; width: 250px; z-index: 1; display: none;">
                            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                                <div class="col s9 no-padding">Epaisseur</div>
                                <div class="col s3 no-padding">
                                    <input id="tool-size-input" type="number" min="1" max="800">
                                </div>
                            </div>
                            <div class="col s12 no-padding">
                                <div id="tool-size-range" class="col s12 row"></div>
                            </div>
                            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                                <div class="col s9 no-padding">Dureté</div>
                                <div class="col s3 no-padding">
                                    <input id="tool-hardness-input" type="number" step="0.01" min="0" max="1">
                                </div>
                            </div>
                            <div class="col s12 no-padding">
                                <div id="tool-hardness-range" class="col s12 row"></div>
                            </div>
                        </div>
                    </div>
                    <div id="tool-setting-exposition"
                        style="display: none; float: left; flex-direction: row; align-items: center; margin-left: 10px;">
                        <div style="font-size: 12px">Exposition :</div>
                        <div style="margin-left: 10px;">
                            <input id="tool-setting-exposition-input" style="height: 30px; width: 50px; margin: 0;"
                                type="number" step="0.01" min="0" max="1">
                        </div>
                    </div>
                </div>
                <div id="tool-setting-rotation" style="display: none;">
                    <div style="float: left; display: flex; flex-direction: row; align-items: center; margin-left: 10px;">
                        <div style="font-size: 12px">Angle :</div>
                        <div style="margin-left: 10px;">
                            <input id="tool-setting-rotation-input-button" style="height: 30px; width: 50px; margin: 0;"
                                type="number" step="1" min="-180" max="180">
                        </div>
                    </div>
                    <div style="float: left; display: flex; flex-direction: row; align-items: center; margin-left: 10px;">
                        <input id="tool-setting-rotation-input-slider" type="range" step="1" min="-180" max="180">
                    </div>
                </div>
            </div>
            <div class="divider" style="background-color: #282828"></div>
        `;
    }

    tool_setting_sizeHardnessOnCLick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.edit = !this.photoshopController.PSEngine.activeOperation.edit;
    }

    tool_size_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.size = value;
        this.photoshopController.update();
    }

    tool_hardness_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.hardness = value;
        this.photoshopController.update();
    }

    tool_setting_exposition_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.exposure = value;
        this.photoshopController.update();
    }

    tool_setting_rotation_input_buttonOnChange(value) {
        this.photoshopController.layerRotation(value);
        this.photoshopController.update();
    }

    tool_setting_rotation_input_sliderOnChange(value) {
        this.photoshopController.layerRotation(value);
        this.photoshopController.update();
    }

    updateModel() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation) {
            if (this.photoshopController.PSEngine.activeOperation.size !== undefined) {
                const toolSizeInput = document.getElementById("tool-size-input") as HTMLInputElement | null;
                if (toolSizeInput) {
                    toolSizeInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.size;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.hardness !== undefined) {
                const toolHardnessInput = document.getElementById("tool-hardness-input") as HTMLInputElement | null;
                if (toolHardnessInput) {
                    toolHardnessInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.hardness;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.exposure !== undefined) {
                const expositionInput = document.getElementById("tool-setting-exposition-input") as HTMLInputElement | null;
                if (expositionInput) {
                    expositionInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.exposure;
                }
            }
            this.size = document.getElementById("tool-setting-size");
            if (this.size) {
                this.size.innerHTML = this.photoshopController.PSEngine.activeOperation.size;
            }
        }
        const rotationValue = this.photoshopController.layerRotation();
        if (rotationValue !== undefined && !isNaN(rotationValue)) {
            const rotationInputButton = document.getElementById("tool-setting-rotation-input-button") as HTMLInputElement | null;
            if (rotationInputButton) {
                rotationInputButton.value = rotationValue.toString();
            }
            const rotationInputSlider = document.getElementById("tool-setting-rotation-input-slider") as HTMLInputElement | null;
            if (rotationInputSlider) {
                rotationInputSlider.value = rotationValue.toString();
            }
        }
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.type === 'TOOL') {
            const toolSettingElem = document.getElementById("tool-setting");
            if (toolSettingElem) {
                toolSettingElem.style.display = "";
            }
        } else {
            const toolSettingElem = document.getElementById("tool-setting");
            if (toolSettingElem) {
                toolSettingElem.style.display = "none";
            }
        }

        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'density') {
            const expositionElem = document.getElementById("tool-setting-exposition");
            if (expositionElem) {
                expositionElem.style.display = "flex";
            }
        } else {
            const expositionElem = document.getElementById("tool-setting-exposition");
            if (expositionElem) {
                expositionElem.style.display = "none";
            }
        }

        if (this.photoshopController.PSRotationMode) {
            const rotationElem = document.getElementById("tool-setting-rotation");
            if (rotationElem) {
                rotationElem.style.display = "";
            }
        } else {
            const rotationElem = document.getElementById("tool-setting-rotation");
            if (rotationElem) {
                rotationElem.style.display = "none";
            }
        }
    }

    updateShow() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.edit) {
            const sizeHardnessShowElem = document.getElementById("tool-setting-sizeHardness-show");
            if (sizeHardnessShowElem) {
                sizeHardnessShowElem.style.display = "";
            }
        } else {
            const sizeHardnessShowElem = document.getElementById("tool-setting-sizeHardness-show");
            if (sizeHardnessShowElem) {
                sizeHardnessShowElem.style.display = "none";
            }
        }
    }

    initializeToolRange() {
        window.setTimeout(() => {
            if (!this.photoshopController.PSEngine) {
                return;
            }
            var toolSizeRange = document.getElementById("tool-size-range");
            if (toolSizeRange) {
                if (toolSizeRange.noUiSlider) {
                    toolSizeRange.noUiSlider.destroy();
                }
                noUiSlider.create(toolSizeRange, {

                    start: [this.photoshopController.PSEngine.activeOperation.size],
                    step: 1,
                    range: {
                        min: 1,
                        max: 800
                    }
                });
                if (toolSizeRange.noUiSlider) {
                    toolSizeRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.size = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const toolSizeInputElem = document.getElementById('tool-size-input');
                if (toolSizeInputElem) {
                    toolSizeInputElem.addEventListener('change', function (event) {
                        this.tool_size_inputOnChange((event.currentTarget as HTMLInputElement).valueAsNumber);
                        if (toolSizeRange && toolSizeRange.noUiSlider) {
                            toolSizeRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).valueAsNumber]);
                        }
                    }.bind(this));
                }
            }

            var toolHardnessRange = document.getElementById("tool-hardness-range");
            if (toolHardnessRange) {
                if (toolHardnessRange.noUiSlider) {
                    toolHardnessRange.noUiSlider.destroy();
                }
                noUiSlider.create(toolHardnessRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.hardness],
                    step: 0.01,
                    range: {
                        min: 0,
                        max: 1
                    }
                });
                if (toolHardnessRange.noUiSlider) {
                    toolHardnessRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.hardness = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const toolHardnessInputElem = document.getElementById('tool-hardness-input');
                if (toolHardnessInputElem) {
                    toolHardnessInputElem.addEventListener('change', function (event) {
                        this.tool_hardness_inputOnChange((event.currentTarget as HTMLInputElement).valueAsNumber);
                        if (toolHardnessRange && toolHardnessRange.noUiSlider) {
                            toolHardnessRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).valueAsNumber]);
                        }
                    }.bind(this));
                }
            }
        });
    }
}